<div class="container">
    <div class="wrapper">
        <div class="header">
            <div class="left-section">
                <img [src]="labelIcon">
                <div class="heading">
                    <h3>{{label}}</h3>
                    <p>{{percentage}} % • {{count}} {{ count > 1 ? ('reporting.USERS' | transloco) : ('reporting.USER' | transloco) }}</p>
                </div>
                
            </div>
            <div class="right-section">
                <div class="csv-wrapper" [ngClass]="{'disable-csv': isReportDownloading}" (click)="downloadReport()">
                    <div class="csv">{{'reporting.DOWNLOAD_CSV' | transloco}} <img src="/assets/icons/arrow/arrow-down.svg"></div>
                    <div *ngIf="isErrorReportDownloading" class="error" class="csv-error"><img src="/assets/icons/alert-circle.svg">{{'reporting.ERROR' | transloco}}</div>
                </div>
                <div class="close" (click)="close()">
                    <img src="/assets/icons/x-close-button.svg">
                </div>
            </div>

        </div>
        <div class="body">
            <div *ngIf="isLearnerListLoading">
                <app-three-dots-blinking></app-three-dots-blinking>
            </div>
            <table *ngIf="!isLearnerListLoading">
                <th (click)="setSortField('firstName')">{{'reporting.FIRST_NAME' | transloco}} <img [src]="sortIcon" *ngIf="sortField === 'firstName'"></th>
                <th (click)="setSortField('lastName')">{{'reporting.LAST_NAME' | transloco}} <img [src]="sortIcon" *ngIf="sortField === 'lastName'"></th>
                <th *ngIf="category !== 'NOT_STARTED'" (click)="setSortField('attempts')">{{'reporting.ATTEMPTS' | transloco}} <img [src]="sortIcon" *ngIf="sortField === 'attempts'"></th>
                <th (click)="setSortField('email')">{{'reporting.EMAIL' | transloco}} <img [src]="sortIcon" *ngIf="sortField === 'email'"></th>
                <th (click)="setSortField('lastLogin')">{{'reporting.LAST_LOGIN' | transloco}} <img [src]="sortIcon" *ngIf="sortField === 'lastLogin'"></th>
                <tr *ngFor="let data of learnerList">
                    <td>{{data.firstName}}</td>
                    <td>{{data.lastName}}</td>
                    <td *ngIf="category !== 'NOT_STARTED'">{{data.attempts}}</td>
                    <td>{{data.email}}</td>
                    <td>{{data.formatedDate}}</td>
                </tr>
            </table>

        </div>
    </div>
</div>
